// @flow


export type SetUserPayload = {
  user: ?User,
  idToken: ?string,
}

const id = 'session/SET_USER'

export const setUser = (user: ?User, idToken: ?string): Action<SetUserPayload> => ({
  type: id,
  payload: {
    user,
    idToken,
  }
})

setUser.id = id